"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var brandCenter;
        (function (brandCenter) {
            var customConnector;
            (function (customConnector) {
                function init() {
                    addEvents();
                }
                customConnector.init = init;
                function addEvents() {
                    $('.buildIcon').on('click', function () {
                        const formulaBox = $(this).closest('.input-group').find('.form-control');
                        appn.ui.formulabuilder.currentFormula = formulaBox.val();
                        appn.ui.formulabuilder.currentMode = $(this).data('type');
                        appn.ui.formulabuilder.formulaUpdated = function (formula) {
                            formulaBox.val(formula);
                        };
                        appn.ui.formulabuilder.showDialog();
                    });
                }
            })(customConnector = brandCenter.customConnector || (brandCenter.customConnector = {}));
        })(brandCenter = views.brandCenter || (views.brandCenter = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
